import React from 'react';
import CalculusOfEmotions from '../components/CalculusOfEmotions';

function CalculusOfEmotionsPage() {
  return <CalculusOfEmotions />;
}

export default CalculusOfEmotionsPage;
